import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import $ from "jquery";
import { AppState } from "../../../redux";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { RdvButton } from "../../page-framework/rdv-button";
import { DeactivateAccountModal } from "./deactivate-account-modal";

interface MapDispatchProps {}

interface MapStateProps {
  user: Person;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { user } = props;
  return (
    <div id="account-deactivation" className="settings-section">
      <h4>Deactivate Account</h4>
      <div className="is-grayed">
        <RdvButton
          form="change-email-form"
          text="Request account deactivation"
          isLoading={false}
          disabled={false}
          onClick={() => {
            $("#deactivate-account-modal").modal("show");
          }}
        />
      </div>
      <DeactivateAccountModal />
    </div>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const AccountDeactivation = connect(mapState, mapDispatch)(Component);
